export default {"src":"/assessments/student/_next/static/media/logo.29f778cf.svg","height":36,"width":140,"blurWidth":0,"blurHeight":0};